// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreateStandardUserCreateStandardUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreateStandardUserCreateStandardUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreateStandardUserCreateStandardUserResponse.discriminator = undefined;
AuthenticationV2UserCreateStandardUserCreateStandardUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=authenticationV2UserCreateStandardUserCreateStandardUserResponse.js.map